<template>
  <section id="landing" class="scrolly-overlay">
    <!-- sticky container -->
    <div class="scrolly__sticky">
      <!-- video background -->
      <div class="video-wrapper">
        <video
          preload="none"
          poster="@/assets/img/brivideo-poster.jpg"
          ref="briVideo"
          autoplay
          loop
          muted>

          <source src="@/assets/video/BRI.mp4" type="video/mp4">
          Your browser doesn't support HTML5 video.
        </video>
      </div>
    </div>

    <!-- steps container -->
    <v-container inner class="scrolly__text py-0">
      <div class="step" data-step="1">
        <v-layout class="wrap fill-height justify-center align-content-center" style="position: relative;">
          <div class="text-block text-xs-center white--text">
            <p class="font-secondary">People & Society / Asia-wide</p>

            <h1 class="display-4 font-secondary white--text my-3">Understanding the <br> Belt & Road</h1>

            <address class="font-secondary mb-2">by Peiying Loh</address>

            <time class="font-secondary">
              <strong class="mr-1">Published</strong> 11 November 2018
            </time>

            <p class="body-1 font-weight-bold font-italic mt-5">
              <fa-icon icon="hand-pointer" fixed-width /> Interactions become available in the map when you see the hand pointer icon. You will also be able to click, hold and drag to move the map around.
            </p>
          </div>

          <!-- mouse scroller icon -->
          <div class="mousey-scroller">
            <div class="mousey">
              <div class="mousey__wheel" />
            </div>
          </div>
        </v-layout>
      </div>

      <div class="step" data-step="1">
        <v-layout class="wrap fill-height align-center">
          <div class="text-block text-xs-center">
            <p class="headline white--text mb-3 mt-3">
              Back in September 2013, President Xi Jinping first introduced the Silk Road Economic Belt during his visit to Kazakhstan. Just a month later, he gave another speech to the Indonesian parliament and proposed the 21st Century Maritime Silk Road. Together, these two features are now dubbed the Belt, Road Initiative (or sometimes, One Belt, One Road).
            </p>
          </div>
        </v-layout>
      </div>

      <div class="step" data-step="1">
        <v-layout class="wrap fill-height align-center">
          <div class="text-block text-xs-center">
            <p class="headline white--text mb-5">
              Both initiatives aim at creating trade habitats across the globe that will cultivate multilateral economic cooperation and connectivity. In order to do so, infrastructure is key. To this, China is investing all across the globe mainly in transport and energy.
            </p>
          </div>
        </v-layout>
      </div>
    </v-container>
  </section>
</template>

<script>
import scrollama from 'scrollama';

export default {
  name: 'SectionLanding2',
  mounted() {
    this.initScrollama();
  },
  methods: {
    initScrollama() {
      // instantiate scrollama
      const scrollerLanding = scrollama();

      // setup scrollama
      scrollerLanding.setup({
        container: '#landing',
        graphic: '#landing .scrolly__sticky',
        step: '#landing .scrolly__text .step', // required
        offset: 64 / window.innerHeight, // after navbar height
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
#landing {
  .scrolly__sticky {
    height: 0;

    .video-wrapper {
      position: relative;

      &:before {
        content: '';
        background: rgba(0, 0, 0, 0.6);
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
      }
    }
  }

  .scrolly__text {
    .step {
      .text-block {
        background-color: transparent;

        .headline {
          line-height: 1.5 !important;
        }
      }
    }

    .mousey-scroller {
      position: absolute;
      bottom: 48px;
      width: 34px;

      .mousey {
        box-sizing: content-box;
        opacity: 0.75;
        width: 3px;
        height: 23px;
        padding: 5px 8px;
        margin: auto;
        border: 2px solid #fff;
        border-radius: 25px;

        .mousey__wheel {
          width: 3px;
          height: 7px;
          border-radius: 25%;
          background-color: #fff;
          animation-name: mouseywheel;
          animation-duration: 2.2s;
          animation-timing-function: cubic-bezier(0.15, 0.41, 0.69, 0.94);
          animation-iteration-count: infinite;
        }
      }
    }
  }
}

@keyframes mouseywheel {
  0% { opacity: 0; }
  10% { transform: translateY(0); opacity: 1; }
  100% { transform: translateY(15px); opacity: 0;}
}
</style>
